import { Box, Stack, Typography } from "@mui/material";
import { formatMoney } from "../roiUtils";

interface RoiBarsProps {
  timeSavings: number;
  errorSavings: number;
  flowentiCost: number;
  flowentiPlanName: string;
  flowentiPlanProcessLimit: number;
}

export default function RoiBars({
  timeSavings,
  errorSavings,
  flowentiCost,
  flowentiPlanName,
  flowentiPlanProcessLimit,
}: RoiBarsProps) {
  const rows = [
    { label: "Risparmio su tempo", value: timeSavings, color: "#54bdc1" },
    { label: "Risparmio su errori", value: errorSavings, color: "#1e355f" },
    {
      label: `Costo Flowenti ${flowentiPlanName} (fino a ${flowentiPlanProcessLimit} processi)`,
      value: flowentiCost,
      color: "#e24b4a",
    },
  ];
  const max = Math.max(...rows.map((row) => row.value), 1);

  return (
    <Stack spacing={2.5}>
      {rows.map((row) => (
        <Box key={row.label}>
          <Stack direction="row" justifyContent="space-between" gap={2} sx={{ mb: 0.75 }}>
            <Typography fontWeight={700}>{row.label}</Typography>
            <Typography
              color="text.secondary"
              fontFamily="monospace"
              fontWeight={800}
              sx={{ whiteSpace: "nowrap" }}
            >
              {formatMoney(row.value)}
            </Typography>
          </Stack>
          <Box
            sx={{
              height: 12,
              borderRadius: 999,
              backgroundColor: "action.hover",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                width: `${Math.max((row.value / max) * 100, 4)}%`,
                height: "100%",
                borderRadius: 999,
                backgroundColor: (theme) =>
                  theme.palette.mode === "dark" && row.color === "#1e355f"
                    ? theme.palette.secondary.light
                    : row.color,
              }}
            />
          </Box>
        </Box>
      ))}
    </Stack>
  );
}
